import { CSSProperties, memo, useCallback } from 'react';

import { useAppSelector } from '@/store/hooks';
import useLoadCategories from '@/connection/hooks/use-load-categories';
import { getCategories, getIsLoadingCategories } from '@/store/slices/categories/selectors';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import TruncatedCreatableMultiReactSelect from '@ui/select/react-select/truncated-creatable-multi-react-select/truncated-creatable-multi-react-select';

type CoursesCategoriesSelectProps = {
  defaultCategories?: TReactSelectOption[];
  onMenuClose: (selectedCategories: TReactSelectOption[]) => void;
  disabled?: boolean;
  viewableItems?: number;
  controlWidth?: CSSProperties['width'];
};

const CoursesCategoriesSelect = memo(
  ({ disabled, defaultCategories, onMenuClose, controlWidth, viewableItems = 1 }: CoursesCategoriesSelectProps) => {
    useLoadCategories({ skipIfCategoriesExist: true });

    const loadingCategories = useAppSelector(getIsLoadingCategories);
    const channelCategories = useAppSelector(getCategories);

    const handleMenuClose = useCallback(
      (selectedCategories: TReactSelectOption[]) => {
        onMenuClose(selectedCategories);
      },
      [onMenuClose]
    );

    return (
      <TruncatedCreatableMultiReactSelect
        showHeader={false}
        label="CATEGORIES"
        placeholder="Add categories"
        defaultValue={defaultCategories}
        disabled={disabled}
        isLoading={loadingCategories}
        controlWidth={controlWidth}
        viewableItems={viewableItems}
        onMenuClose={handleMenuClose}
        options={(channelCategories || [])?.map((c) => ({
          label: c.toString(),
          value: c.toString(),
        }))}
      />
    );
  }
);

export default CoursesCategoriesSelect;
